const mixinRowInit = {
  methods: {
    initRow(obj) {
      const items = this.items
      if (items?.length) {
        items.map(item => {
          switch (item.type) {
            case 'checkbox':
              obj[item.prop] = []
              break
            case 'datetimerange': {
              // const end = new Date()
              // const start = new Date()
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              obj[item.prop] = ['', '']
              break
            }
            case 'timerange': {
              // const end = new Date()
              // const start = new Date()
              // start.setTime(start.getTime() - 3600 * 1000)
              obj[item.prop] = ['', '']
              break
            }
            default:
              obj[item.prop] = ''
          }
        })
      }
      return obj
    }
  }
}

export default mixinRowInit
